export default {
    logged_user: null
}
